import React, { Component, Fragment } from "react";
import {
	TitleStep,
	SubTitleStep,
	InputSubmit,
} from "./../../../StyledComponents";
import { RowContainer, SpanIndent } from "./../StyledComponents";

import { connect } from "react-redux";
import {
	setSurveyAnswers,
	simulationSetEmplacementLocationsTypes,
} from "./../../../../../redux/actions/surveyActions";
import _ from "lodash";
import {
	StratForm,
	StratInputNumber,
	StratLabel,
	StratSelect,
	StratSelectOption,
} from "./../StyledComponents";
import ConfirmButton from "./../../../../buttons/ConfirmButton";

class EmplacementQuestion extends Component {
	constructor(props) {
		super(props);
		this.state = {
			locationTypes: [],
			countEmptyRanges: 0,
			countFilledRanges: 0,
		};
	}

	/**
	 * Add or remove location
	 * @param value
	 * @param lt
	 * @param locationTypeId
	 * @param label
	 */
	handleChangeLocations(value, lt, locationTypeId, label) {
		let locationTypes = this.props.emplacementLocationsTypes;
		let previousLocationTypes = _.cloneDeep(
			this.props.emplacementLocationsTypes
		);
		let previousLocations = locationTypes[lt]
			? locationTypes[lt].locations
			: {};

		locationTypes[lt] = { locationTypeId, label, locations: [] };

		//remove statement with no kpis
		const filteredStatements = this.props.locationTypes[lt].statements || [];
		_.remove(filteredStatements, statement => {
			return !statement || !statement.kpis || statement.kpis.length === 0;
		});

		// for each location in locationType, populate array
		for (let a = 0; a < value; a++) {
			let previousCategories =
				locationTypes &&
				previousLocationTypes[lt] &&
				previousLocationTypes[lt].locations &&
				previousLocationTypes[lt].locations[a] &&
				previousLocationTypes[lt].locations[a].categories
					? previousLocationTypes[lt].locations[a].categories
					: [];

			const locationNumber = a + 1;
			locationTypes[lt].locations[a] = {
				locationTypeId: `${lt}${a}`,
				label: label + " " + locationNumber,
				categories: previousCategories,
				statements: filteredStatements,
				positionLabel: previousLocations[a]
					? previousLocations[a].positionLabel
					: "",
			};
		}

		// setstate
		this.setState({
			//locationTypes: locationTypes,
			countEmptyRanges: value,
		});

		this.props.simulationSetEmplacementLocationsTypes(locationTypes);
	}

	/**
	 * @param value
	 * @param lt LocationType index
	 * @param l location index
	 * @param c category index
	 * @param category current category
	 */
	handleChangeCategoryRanges(value, lt, l, c, category = {}) {
		let locationTypes = this.props.emplacementLocationsTypes;
		let rangeIndex = _.findIndex(this.props.ranges, { rangeId: value });

		let rangeName =
			rangeIndex !== -1 ? this.props.ranges[rangeIndex].label : "";
		let positionLabel = `${rangeName}`;

		// get current location and add categories with their range
		locationTypes[lt].locations[l].positionLabel = positionLabel;

		locationTypes[lt].locations[l].categories[c] = {
			categoryId: category.categoryId,
			label: category.label,
			rangeId: value,
			families: this.props.locationTypes[lt].categories[c].families,
		};

		//set families ranges = category range
		const categoryFamilies =
			locationTypes[lt].locations[l].categories[c].families || [];
		for (let i = 0; i < categoryFamilies.length; i++) {
			const categoryFamily = categoryFamilies[i];
			categoryFamily.rangeId = value;
		}

		this.setState({
			//locationTypes: locationTypes,
			countFilledRanges: this.state.countFilledRanges + 1,
		});

		this.props.simulationSetEmplacementLocationsTypes(locationTypes);
	}

	/**
	 * handle family strat selection
	 * @param value
	 * @param lt LocationType index
	 * @param l location index
	 * @param c category index
	 * @param f family index
	 * @param family
	 */
	handleChangeFamilyRanges(value, lt, l, c, f, family) {
		let locationTypes = this.props.emplacementLocationsTypes;
		let rangeIndex = _.findIndex(this.props.ranges, { rangeId: value });
		let rangeName =
			rangeIndex !== -1 ? this.props.ranges[rangeIndex].label : "";
		let positionLabel = `${rangeName}`;

		// get current location and add categories with their range
		locationTypes[lt].locations[l].positionLabel = positionLabel;

		locationTypes[lt].locations[l].categories[c].families[f] = {
			familyId: family.familyId,
			label: family.label,
			rangeId: value,
			brands: this.props.locationTypes[lt].categories[c].families[f].brands,
		};

		this.setState({
			countFilledRanges: this.state.countFilledRanges + 1,
		});

		this.props.simulationSetEmplacementLocationsTypes(locationTypes);
	}

	handleSubmit() {
		// create json visit {} object
		let json = {
			metier: {
				locationTypes: this.props.locationTypes,
				ranges: this.props.ranges,
			},
		}; // received json

		json.visit = this.props.emplacementLocationsTypes; // json.visit {} object with survey

		// check all locations and add default rangeId if category has no randeId
		json.visit.map((locationType, lt) => {
			locationType.locations.map((location, l) => {
				_.find(json.metier.locationTypes, {
					locationTypeId: locationType.locationTypeId,
				}).categories.map((category, c) => {
					if (location.categories.length == 0) {
						location.categories[c] = {
							categoryId: category.categoryId,
							label: category.label,
							rangeId:
								json.metier.ranges[json.metier.ranges.length - 1].rangeId,
							families: category.families,
						};
					}
				});
			});
		});

		this.props.setSurveyAnswers(json.visit);
		this.props.handleSubmit();
	}

	getStratValue(lt, l, c, f = null) {
		const locationTypes = this.props.emplacementLocationsTypes;

		const categoryRangeId =
			locationTypes &&
			locationTypes[lt] &&
			locationTypes[lt].locations &&
			locationTypes[lt].locations[l].categories &&
			locationTypes[lt].locations[l].categories[c]
				? locationTypes[lt].locations[l].categories[c].rangeId
				: "";

		if (f !== null) {
			return locationTypes &&
				locationTypes[lt] &&
				locationTypes[lt].locations &&
				locationTypes[lt].locations[l].categories &&
				locationTypes[lt].locations[l].categories[c] &&
				locationTypes[lt].locations[l].categories[c].families &&
				locationTypes[lt].locations[l].categories[c].families[f]
				? locationTypes[lt].locations[l].categories[c].families[f].rangeId ||
						categoryRangeId
				: categoryRangeId;
		}

		return categoryRangeId;
	}

	isFormCompleted() {
		const { emplacementLocationsTypes } = this.props;
		const json = {
			metier: {
				ranges: this.props.ranges,
				locationTypes: this.props.locationTypes,
			},
		};

		if (!emplacementLocationsTypes || !emplacementLocationsTypes.length > 0) {
			return false;
		}

		let formCompleted = true;
		emplacementLocationsTypes.map((locationType, lt) => {
			if (emplacementLocationsTypes[lt].locations.length === 0) {
				formCompleted = false;
			}
			emplacementLocationsTypes[lt].locations.map((location, l) => {
				const locationTypeFromJson =
					_.find(json.metier.locationTypes, {
						locationTypeId: locationType.locationTypeId,
					}) || {};
				const categoriesFromJson = locationTypeFromJson.categories || [];

				categoriesFromJson.map((category, c) => {
					if (!this.getStratValue(lt, l, c)) {
						formCompleted = false;
					}
				});
			});
		});
		return formCompleted;
	}

	/**
	 * Render family strat selection
	 * @param family
	 * @param category
	 * @param lt
	 * @param l
	 * @param c
	 * @param f
	 * @returns {*}
	 */
	renderFamilySelect(family, category, lt, l, c, f) {
		const json = {
			metier: {
				ranges: this.props.ranges,
				locationTypes: this.props.locationTypes,
			},
		};

		if(family.label=== "default") return null;
		return (
			<RowContainer>
				<StratLabel>{family.label} :</StratLabel>
				<StratSelect
					value={this.getStratValue(lt, l, c, f)}
					onChange={event =>
						this.handleChangeFamilyRanges(event, lt, l, c, f, family)
					}
				>
					{// for each range, select the one for current category
					json.metier.ranges.map((range, r) => {
						return (
							<StratSelectOption value={range.rangeId} key={r}>
								{range.label}
							</StratSelectOption>
						);
					})}
				</StratSelect>
			</RowContainer>
		);
	}

	/**
	 * Display families strat selection
	 * @param category
	 * @param lt
	 * @param l
	 * @param c
	 * @returns {Array}
	 */
	displayFamilies(category = {}, lt, l, c) {
		const families = category.families || [];
		const items = [];
		families.map((family, f) => {
			items.push(this.renderFamilySelect(family, category, lt, l, c, f));
		});

		return items;
	}

	render() {
		const { emplacementLocationsTypes } = this.props;
		const json = {
			metier: {
				ranges: this.props.ranges,
				locationTypes: this.props.locationTypes,
			},
		};

		return (
			<Fragment>
				<div className="p-mrg-top p-brd-bot p-pdg-bot p-mrg-bot">
					Pour chaque type d'emplacement, indiquer le nombre présents dans le
					magasin :
				</div>

				<StratForm>
					{// for each locationType, ask how many location
					json.metier.locationTypes.map((locationType, lt) => {
						return (
							<div className="inputItem" key={lt}>
								<RowContainer type="flex" justify="start" align="middle">
									<StratLabel>{locationType.label} :</StratLabel>
									<StratInputNumber
										value={
											emplacementLocationsTypes[lt]
												? emplacementLocationsTypes[lt].locations.length
												: ""
										}
										min="0"
										onChange={event =>
											this.handleChangeLocations(
												event,
												lt,
												locationType.locationTypeId,
												locationType.label
											)
										}
									/>
								</RowContainer>
							</div>
						);
					})}
					{emplacementLocationsTypes.length > 0 ? (
						// for each locationType
						<div>
							{emplacementLocationsTypes.map((locationType, lt) => {
								return (
									<div key={lt}>
										{// for each location in locationType
										emplacementLocationsTypes[lt].locations.map(
											(location, l) => {
												const locationTypeFromJson =
													_.find(json.metier.locationTypes, {
														locationTypeId: locationType.locationTypeId,
													}) || {};
												const categoriesFromJson =
													locationTypeFromJson.categories || [];
												return (
													<Fragment key={l}>
														<StratLabel>
															<b className="p-survey-simulation-ranges-location">
																{location.label} :
															</b>
														</StratLabel>
														<div>
															{//render families strat selection
															categoriesFromJson.map((category, c) => {
																return (
																	<div key={c}>
																		<RowContainer>
																			<StratLabel>
																				Catégorie {category.label} :
																			</StratLabel>
																			<StratSelect
																				id="interet"
																				onChange={event =>
																					this.handleChangeCategoryRanges(
																						event,
																						lt,
																						l,
																						c,
																						category
																					)
																				}
																				placeholder="Choisir la strate"
																				value={this.getStratValue(lt, l, c)}
																			>
																				{// for each range, select the one for current category
																				json.metier.ranges.map((range, r) => {
																					return (
																						<StratSelectOption
																							value={range.rangeId}
																							key={r}
																						>
																							{range.label}
																						</StratSelectOption>
																					);
																				})}
																			</StratSelect>
																		</RowContainer>
																		{//render families strat selection
																		this.getStratValue(lt, l, c) && true
																			? this.displayFamilies(category, lt, l, c)
																			: null}
																	</div>
																);
															})}
														</div>
													</Fragment>
												);
											}
										)}
									</div>
								);
							})}
						</div>
					) : null}
				</StratForm>
				{// display validate button only if all family range are filled
				// controls should be better with form fields
				this.isFormCompleted() && (
					<div className="p-al-r-center p-mrg-top-s">
						<ConfirmButton
							label="Valider"
							large={true}
							onClick={() => this.handleSubmit()}
							classes=""
						/>
					</div>
				)}
			</Fragment>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	let ranges = [];
	let models = state.survey.surveyManager.surveyProgress.model;
	if (models && models[0] && models[0].ranges) {
		ranges = models[0].ranges;
	}

	/**
	 * surveyAnswers = json.visit
	 * json.metiers = {
	 *   locationTypes:locationTypes,
	 *   ranges:ranges
	 * }
	 */
	return {
		surveyAnswers: state.survey.simulationManager.surveyAnswers,
		ranges: ranges,
		locationTypes: state.survey.simulationManager.locationTypes,
		emplacementLocationsTypes:
			state.survey.simulationManager.emplacementLocationsTypes,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setSurveyAnswers: surveyAnswers => {
			dispatch(setSurveyAnswers(surveyAnswers));
		},
		simulationSetEmplacementLocationsTypes: locationsTypes => {
			dispatch(simulationSetEmplacementLocationsTypes(locationsTypes));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EmplacementQuestion);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/EmplacementQuestion.js